// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** Standard error codes returned by operations. */
export enum ErrorCode {
    /** Target resource does not exist in the database. */
    ResourceNotFound = 'ResourceNotFound',

    /** The state of target resource is not valid for the operation. */
    InvalidState = 'InvalidState',

    /** The operation cannot obtain GitHub access token for the user. */
    MissingGitHubAccess = 'MissingGitHubAccess',

    /** The operation cannot obtain GitHub SAML access for the user. */
    GitHubSAMLRequired = 'GitHubSAMLRequired',

    /** The root course YAML file index.yml is missing from curriculum repo. */
    MissingCourseFile = 'MissingCourseFile',

    /** Target resource has metadata has validation errors. */
    ValidationError = 'ValidationError',

    /** General operation failure (exception). */
    OperationFailed = 'OperationFailed',

    /** Operation has reached maximum number of retries. */
    MaxRetriesReached = 'MaxRetriesReached',
}
